export const GET_LIST_GIFT = 'GET_LIST_GIFT'
